import { Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import KundenDataTable from "../../components/kunden/KundenDataTable";
import { useT } from "../../i18n";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function KundenListe() {
  const { t } = useT("customer");
  const limit = parseInt(localStorage.getItem("kundenLimit") ?? "25", 10);
  return (
    <Layout title={t("customers")} showTitleInNav={false}>
      <Guard
        permission={"kunde:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">{t("customers")}</Typography>
          <KundenDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
